import React from "react";
import "./loader.css";

const Loader = ({ text = "Extracting data..." }) => {
  return (
    <div className="loader-container">
      <div>
        <div className="lds-hourglass"></div>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default Loader;
